const Problems = [
  {
    id: 1,
    question: "あなたの性別は？",
    answers: [
      { name: "sex", label: "男性", value: "1" },
      { name: "sex", label: "女性", value: "2" },
    ],
  },
  {
    id: 2,
    question: "あなたの年代は？",
    answers: [
      { name: "age", label: "20代", value: "1"  },
      { name: "age", label: "30代", value: "2"  },
      { name: "age", label: "40代", value: "3"  },
      { name: "age", label: "50代～", value: "4"  },
    ],
  },
  {
    id: 3,
    question: "ご結婚は？",
    answers: [
      { name: "married", label: "してる", value: "1"  },
      { name: "married", label: "してない", value: "2"  },
    ],
  },
  {
    id: 4,
    question: "お子さまは？",
    answers: [
      { name: "child", label: "いる", value: "1"  },
      { name: "child", label: "いない", value: "2"  },
    ],
  },
  {
    id: 5,
    question: "お子さまの希望は？",
    answers: [
      { name: "hope", label: "ある", value: "1"  },
      { name: "hope", label: "ない", value: "2"  },
    ],
  },
];

export default Problems
